module.exports = __webpack_public_path__ + "static/media/logo.405b232b.png";